import React, { useState } from 'react';
import Spinner from './Spinner';
import { Transition } from 'react-transition-group';

const FadeInSpinner = ({ loading }: { loading: boolean }): JSX.Element => {
  const transition = {
    entering: 'opacity-0',
    entered: 'opacity-100',
    exiting: 'opacity-100',
    exited: 'opacity-0',
  };
  const [showSpinner, setShowSpinner] = useState(false);

  return (
    <div className={`flex justify-around items-center`}>
      <Transition
        in={loading}
        timeout={300}
        onEnter={() => {
          setShowSpinner(true);
        }}
        onExited={() => {
          setShowSpinner(false);
        }}
      >
        {(state: 'entering' | 'entered' | 'exiting' | 'exited') => (
          <div
            className={`
              h-16 w-16 absolute
              z-spinner
              transition-all duration-300 
              transform translate-y-16 
              ${transition[state]}`}
          >
            {showSpinner && <Spinner color="yellow" spin={showSpinner} />}
          </div>
        )}
      </Transition>
    </div>
  );
};

export default FadeInSpinner;

// h-16 w-16 absolute
// transition-all duration-300
// transform -translate-y-16
